import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import dayjs from "dayjs";

const state = {
  date: dayjs().format("YYYY-MM-DD"),
  classify: {
    storeNo: 0,
    data: {
      ACCUMULATE_INQUIRY: 0,
      ACCUMULATE_ORDER: 0,
      ACCUMULATE_PHONE: 0
    }
  },
  transaction: {
    storeNo: 0,
    periodCondition: '',
    data: {}
  },
  countAndSales: {
    storeNo: 0,
    countPeriodCondition: '',
    salesPeriodCondition: '',
    orderCondition: '',
    countData: {},
    salesData: {}
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
